export default object => ({
  id: object.id,
  reference: object.reference,
  fileStream: null,

  files: object.files.map(({ id, fileName, key, url }) => ({
    id,
    name: fileName,
    key,
    url,
  })) || [],
});
